module.exports = __webpack_public_path__ + "img/yunyingguanli.0c65b3e5.png";